import { createIconComponent } from '../../factory/create-icon-component';
export const EmailIcon = createIconComponent(
  'EmailIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2"
      y="3"
      width="20"
      height="18"
      rx="5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M6 8L7 8.66667C8.60965 9.73977 9.41447 10.2763 10.2691 10.5338C11.398 10.8739 12.602 10.8739 13.7309 10.5338C14.5855 10.2763 15.3904 9.73977 17 8.66667L18 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
